
import { Component, Vue, Prop } from "vue-property-decorator";
import Avatar from "@/components/Avatar.vue";
@Component({
  components: {
    Avatar
  }
})
export default class StudentItem extends Vue {
  @Prop({ required: true }) private item!: any;
}
